import Request from './request'

const DiadocDocumentParse  = {
  getDiadocDocumentParsePolicies(params, callback) {
    Request.get('diadoc-document-parse/policies', params).then(callback).catch(this.bad_answer)
  },
  getDiadocDocumentParseHistory(params, callback) {
    Request.get('diadoc-document-parse/results', params).then(callback).catch(this.bad_answer)
  },
}

export default DiadocDocumentParse
